import { async } from "q";
import { attendenace } from "../Reducers/attendance_reducer";
import { EMP_ATTENDANCE } from "../action_types";
import moment from "moment";
const token = JSON.parse(localStorage.getItem('key'));
let SERVER_URL = process.env.REACT_APP_API_URL;

export const get_today_in_out_time = (state) => async (dispatch) => {
    var att_date = moment().format("YYYY-MM-DD");
    let token_l = JSON.parse(localStorage.getItem('key'));
    const response = fetch(SERVER_URL + `api/attendance/firstIn-lastOut-time`,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token_l.value}`
            },
            body: JSON.stringify({ EmpID: state, currentdat: att_date }),
        }).then(res => res.json())
        .then(data => {
            if (data.status == true) {
                const in_out_time = {
                    inTime: '',
                    outTime: ''
                }
                if (data?.data?.id) {
                    in_out_time.inTime = data?.data.start_time
                    in_out_time.outTime = data?.data.end_time
                } else {
                    in_out_time.inTime = data?.data.start_time
                    in_out_time.outTime = data?.data.end_time
                }
                dispatch({ type: 'EMP_IN_OUT_TIME_IN', payload: in_out_time })
            }
        })

}

export const attendenace_action = (state) => async (dispatch) => {
    let token_l = JSON.parse(localStorage.getItem('key'));

    const response = await fetch(SERVER_URL + `api/attendance/my-attendance-list`,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token_l.value}`
            },
            body: JSON.stringify({
                EmpID: state.emp_id,
                FindMonth: state.date
            })
        }).then(res => res.json())
        .then(data => {
            var attendenace_arr = new Array();
            data?.data?.attendance?.map((item, index) => {
                attendenace_arr[item.day] = item;
                attendenace_arr.push()

                if (item.count > 1) {
                    var att_date = moment(item.att_date).format('YYYY-MM-DD')
                    get_in_out_inDay(att_date, item.day)
                }
            })




            var holiday_arr = new Array();
            data?.data?.officeHoliday?.map((item, index) => {
                holiday_arr[item.day] = item;
                holiday_arr.push()
            })

            var in_out = new Array()
            var totalMinuts = new Array()
            async function get_in_out_inDay(att_date, att_day) {
                let token = JSON.parse(localStorage.getItem('key'));
                await fetch(SERVER_URL + `api/attendance/day-in-out`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: state.emp_id,
                        att_date: att_date
                    })
                }).then(res => res.json()).
                    then(data => {
                        if (data?.data?.length > 1) {
                            var tmp = 0
                            for (var i = 0; i < data?.data?.length; i++) {
                                var startTime = moment(data?.data[i]?.start_time, 'hh:mm:ss a');
                                var endTime = moment(data?.data[i]?.end_time, 'hh:mm:ss a');
                                var totalMinutes = endTime.diff(startTime, 'minutes');
                                tmp = tmp + totalMinutes
                            }
                            totalMinuts[att_day] = tmp
                            totalMinuts.push()

                            in_out[att_day] = data.data;
                            in_out.push()


                        }
                    })
            }


            dispatch({ type: EMP_ATTENDANCE, payload: { attendenace_arr, holiday_arr, in_out, totalMinuts } })
        });

}
export const get_Today_attendance_time = (userId, storeToken) => async (dispatch) => {
    let token_todat_in_out = JSON.parse(localStorage.getItem('key'));
    var att_date = moment().format("YYYY-MM-DD");
    var today_time = new Array()
    await fetch(SERVER_URL + `api/attendance/today-attendance-time`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token_todat_in_out.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            att_date: att_date
        })
    }).then(res => res.json()).
        then(data => {
            today_time['TodayHRS'] = data.data;
            today_time.push()
        })
    dispatch({ type: 'EMP_TODAT_ATTENDANCE_TIME', payload: { today_time } })
}
export const get_punch_in_time = (userId, storeToken) => async (dispatch) => {

    var att_date = moment().format("YYYY-MM-DD");
    await fetch(SERVER_URL + `api/attendance/today-punch-in-time`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${storeToken}`
        },
        body: JSON.stringify({
            EmpID: userId,
            att_date: att_date
        })
    }).then(res => res.json()).
        then(data => {

            const currentTime = moment().format('HH:mm:ss a');
            var startTime = moment(data?.data, 'HH:mm:ss a');
            var endTime = moment(currentTime, 'HH:mm:ss a');

            var DiffAB = endTime.diff(startTime);

            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN', payload: { DiffAB } })

        })
}

export const get_user_presents_in_month = (year, month, userId, storeToken) => async (dispatch) => {

    const from_date = moment(year + '-' + month, "YYYY-MM").format("YYYY-MM") + '-01';

    const to_date = moment(year + '-' + month, "YYYY-MM").format("YYYY-MM") + '-' + moment(year + '-' + month, "YYYY-MM").daysInMonth()




    await fetch(SERVER_URL + `api/attendance/user-attendance-in-month`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${storeToken}`
        },
        body: JSON.stringify({
            EmpID: userId,
            from_date: from_date,
            to_date: to_date
        })
    }).then(res => res.json()).
        then(data => {
            if (data.status == true) {
                let present = 0;
                data?.data?.map((row, ind) => {
                    if (row.TOTALDAYSMINUTS >= 540) {
                        present += 1;
                    }
                })
                dispatch({ type: 'SET_EMP_PRESENTS_IN_MONTH', payload: { present } })
            }


        })
}

export const get_Punch_Time_In_Month = (userId, storeToken) => async (dispatch) => {
    const from_date = moment().format('YYYY-MM') + '-1';
    const to_date = moment().format('YYYY-MM') + '-' + moment().daysInMonth()
    await fetch(SERVER_URL + `api/attendance/punch-time-in-month`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${storeToken}`
        },
        body: JSON.stringify({
            EmpID: userId,
            from_date: from_date,
            to_date: to_date
        })
    }).then(res => res.json()).
        then(data => {
            const response = data?.data ? data?.data : '';
            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN_MONTH', payload: { response } })
        })
}

export const get_weekly_punch_in_time = (userId, token) => async (dispatch) => {
    var curr = new Date;
    var firstdayofWeek = moment().startOf('isoweek').format("YYYY-MM-DD");
    var lastdayOfWeek = moment().endOf('isoweek').format("YYYY-MM-DD");

    // console.log('firstdayofWeek=>', firstdayofWeek)
    // console.log('lastdayOfWeek=>', lastdayOfWeek)

    await fetch(SERVER_URL + `api/attendance/punch-time-in-week`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            firstdayofWeek: firstdayofWeek,
            lastdayOfWeek: lastdayOfWeek
        })
    }).then(res => res.json()).
        then(data => {
            const week_hrs = data?.data ? data?.data : '';
            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN_WEEK', payload: { week_hrs } })
        })
}
export const get_holidays = (month, year, storeToken) => async (dispatch) => {
    await fetch(SERVER_URL + `api/attendance/get_holiday`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${storeToken}`
        },
        body: JSON.stringify({
            month: month,
            year: year
        })
    }).then(res => res.json()).
        then(data => {
            const holiday = data?.data?.holidays ? data?.data?.holidays : '0';
            dispatch({ type: 'SET_COMPANY_HOLIDAY', payload: { holiday } })
        })
}


export const set_clean_attendance = () => async (dispatch) => {
    var attendenace_arr = new Array();
    var totalMinuts = new Array();
    var holiday_arr = new Array();
    var in_out = new Array()
    dispatch({ type: 'SET_ATTENDANCE_CLEAN', payload: { attendenace_arr, holiday_arr, in_out, totalMinuts } })
}



export const get_HRS_Today = (userdata) => async (dispatch) => {
    const emp_id = userdata?.emp_id;
    const todayDate = userdata?.date;
    const storeToken = userdata?.storeToken;

    await fetch(SERVER_URL + `api/attendance/get-today-hrs`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${storeToken}`
        },
        body: JSON.stringify({
            emp_id: emp_id,
            todayDate: todayDate
        })
    }).then(res => res.json()).
        then(data => {

            var TOTAL_HRS = 0;
            for (var i = 0; i < data?.data?.length; i++) {

                const timeIn = data?.data[i]?.start_time
                const timeOut = data?.data[i]?.end_time
                var startTime = moment(timeIn, 'hh:mm:ss a');
                var endTime = moment(timeOut, 'hh:mm:ss a');

                var totalHours = (endTime.diff(startTime, 'hours'));
                var totalMinutes = endTime.diff(startTime, 'minutes');
                TOTAL_HRS = TOTAL_HRS + totalMinutes
            }

            dispatch({ type: 'SET_USER_TODAY_HRS', payload: { TOTAL_HRS } })
        })

}